import { FC, useRef } from "react"

import { ChatMessage } from "types/tournament.types"

import { ChatMessageItem } from "./ChatMessageItem"

interface ChatMessageListProps {
  messages: ChatMessage[]
  showFilterButton: boolean
  onDelete: (messageId: string) => void
  onRestore: (messageId: string) => void
  onFilter: (playerId: string, playerName: string) => void
}

export const ChatMessageList: FC<ChatMessageListProps> = ({ messages, showFilterButton, onDelete, onRestore, onFilter }) => {
  const chatEndRef = useRef<HTMLDivElement>(null)

  return (
    <div className="max-h-[500px] overflow-y-auto overflow-x-hidden space-y-1 pr-1">
      {messages.map((message) => (
        <ChatMessageItem
          key={message.id}
          message={message}
          showFilterButton={showFilterButton}
          onDelete={onDelete}
          onRestore={onRestore}
          onFilter={onFilter}
        />
      ))}
      <div ref={chatEndRef} />
    </div>
  )
}
